import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-form__item" }
const _hoisted_3 = ["id", "name", "placeholder", "value", "required", "checked", "autocomplete"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "o-form__validation" }
const _hoisted_9 = { class: "o-form__validation__required" }
const _hoisted_10 = { class: "o-form__validation__error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass($options.wrapperClasses)
      }, [
        _createVNode(_component_inputlabel, {
          field: $props.field,
          showInstructions: true
        }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["o-radio__group", { '-is-horizontal': $props.field.inputType === 'switch'}])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.choices, (choice, ci) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "o-radio__wrap",
                key: 'cb-'+ci+'-'+$props.field.id,
                style: {"display":"block"}
              }, [
                _withDirectives(_createElementVNode("input", _mergeProps({
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.field.value) = $event)),
                  class: ["o-radio", { 'readonly': $props.field.inputReadonly === true }]
                }, _toHandlers($data.readOnlyHandlers, true), {
                  type: "radio",
                  id: 'input-' +ci+'-'+$props.field.id,
                  name: $props.field.inputName,
                  placeholder: $props.field.inputPlaceholder,
                  value: (String(choice.value).trim() != '') ? choice.value : choice.text,
                  required: ($props.field.inputRequired === true) ? 'required' : false,
                  checked: ($props.field.value === choice.value || (choice.value=='' && $props.field.value === choice.text)) ? 'checked' : false,
                  autocomplete: ($props.field.inputAutocomplete && $props.field.inputAutocomplete != '' && $props.field.inputAutocomplete != 'querystring' && $props.field.inputAutocomplete != 'reactivevalue' && $props.field.inputAutocomplete != 'cookie') ? $props.field.inputAutocomplete : false
                }), null, 16 /* FULL_PROPS */, _hoisted_3), [
                  [_vModelRadio, $props.field.value]
                ]),
                _createElementVNode("label", {
                  class: "o-radio-label",
                  for: 'input-' + ci + '-' + $props.field.id
                }, [
                  (choice.picto && $data.svgContentMap[choice.picto])
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createElementVNode("span", {
                          innerHTML: $data.svgContentMap[choice.picto]
                        }, null, 8 /* PROPS */, _hoisted_6)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", {
                    innerHTML: (String(choice.text).trim() != '') ? choice.text : choice.value
                  }, null, 8 /* PROPS */, _hoisted_7)
                ], 8 /* PROPS */, _hoisted_4),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}